import { render, staticRenderFns } from "./AdvisorCoreInstructions.vue?vue&type=template&id=6717132c&scoped=true&"
import script from "./AdvisorCoreInstructions.vue?vue&type=script&lang=js&"
export * from "./AdvisorCoreInstructions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6717132c",
  null
  
)

export default component.exports